module.exports = __webpack_public_path__ + "static/media/via.963fdb5e.svg";